module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo-5663d0a25c3cbcd9e3e955cd257ccfd6.png";